import React, { useState, forwardRef, Component } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { find } from 'lodash';
import {APP_COLORS} from "../../common/Constants";
import {faCheck, faXmark} from "@fortawesome/free-solid-svg-icons";
// import {useDispatch} from 'react-redux';
// import {denormCompanyUpdate} from "./entityVerificationsSlice";

export const AttributeRenderer = forwardRef((props, ref) => {
    const attributeDenormPrefix = props.attributeDenormPrefix;
    const attributeValue = props.value;
    const attributeVerified = props.data[attributeDenormPrefix+'Verified'];
    const attributeInvalidated = props.data[attributeDenormPrefix+'Invalidated'];
    const verifiedIcon = attributeVerified ? <FontAwesomeIcon color={APP_COLORS['green']} icon={faCheck}/> : '';
    let isUpdatingCell = false;
    if (props.data._updating && props.data._updating.length > 0) {
        isUpdatingCell = !!find(props.data._updating, _updatingData => _updatingData.attributeDenormPrefix === attributeDenormPrefix);
    }
    // const
    if (isUpdatingCell) {
        return (
            <div style={{
                background: APP_COLORS['gray-400'],
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                padding: '0 8px',
                margin: '0 -8px'
            }}>
            ...  {attributeInvalidated? <span><FontAwesomeIcon color={APP_COLORS['red']} icon={faXmark}/><s>{verifiedIcon} {attributeValue}</s></span>: <span>{verifiedIcon} {attributeValue}</span>}
            </div>
        );
    }

    return (
        <div>
            {attributeInvalidated? <span><FontAwesomeIcon color={APP_COLORS['red']} icon={faXmark}/><s>{verifiedIcon} {attributeValue}</s></span>: <span>{verifiedIcon} {attributeValue}</span>}
        </div>
    );

});
